import { render, staticRenderFns } from "./MetodePengirimanModal.vue?vue&type=template&id=649e3e8e&scoped=true"
import script from "./MetodePengirimanModal.vue?vue&type=script&lang=js"
export * from "./MetodePengirimanModal.vue?vue&type=script&lang=js"
import style0 from "./MetodePengirimanModal.vue?vue&type=style&index=0&id=649e3e8e&prod&lang=css"
import style1 from "./MetodePengirimanModal.vue?vue&type=style&index=1&id=649e3e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e3e8e",
  null
  
)

export default component.exports